import { type MFAConfig, type MFAFactor } from '../../models/MFA'

export const isMFAFactorTypeCompliant = (config: MFAConfig, factors: MFAFactor[]): boolean => {
  if (!config.mfaEnforced) return true
  const { factorType } = config
  if (!factorType?.length) return true
  return factors.some((f) => factorType.includes(f.type))
}
